import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import { message } from 'antd';
import Util from '../../script/util';
import { _dssp_send_click } from '../../store/Action';
import './Share.scss';

class Share extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  //复制链接地址
  copyLink = (e, value) => {
    Util.copyLink(value, () => {
      message.success('链接复制成功!');
      if (this.props.roomid) {
        _dssp_send_click(83, {
          roomid: this.props.roomid,
        });
      }
      if (this.props.dsid) {
        _dssp_send_click(84, {
          dsid: this.props.dsid,
        });
      }
    });
    e.stopPropagation();
  };
  //微博分享
  shareToSinaWB = (e) => {
    let _shareUrl = 'http://v.t.sina.com.cn/share/share.php?';
    _shareUrl += '&url=' + encodeURIComponent(this.props.url);
    _shareUrl += '&title=' + encodeURIComponent(document.title);
    _shareUrl += '&source=&sourceUrl=content=utf-8';
    _shareUrl +=
      '&pic=' + encodeURIComponent(Util.transImgUrl(this.props.pic, '200x200'));
    window.open(_shareUrl, '_blank');
    e.stopPropagation();
  };
  //qq空间分享
  shareToQzone = (e) => {
    let _shareUrl =
      'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?';
    _shareUrl += 'url=' + encodeURIComponent(this.props.url);
    _shareUrl += '&showcount=1';
    _shareUrl += '&desc=' + encodeURIComponent(this.props.remark);
    _shareUrl += '&summary=好玩的小姐姐小哥哥都在这里哟~';
    _shareUrl += '&title=' + encodeURIComponent(document.title);
    _shareUrl +=
      '&site=&pics=' +
      encodeURIComponent(Util.transImgUrl(this.props.pic, '200x200'));
    window.open(_shareUrl, '_blank');
    e.stopPropagation();
  };
  //分享到qq
  shareToqq = (e) => {
    var _shareUrl = 'https://connect.qq.com/widget/shareqq/index.html?';
    _shareUrl += 'url=' + encodeURIComponent(this.props.url); //分享的链接
    _shareUrl += '&title=' + encodeURIComponent(document.title); //分享的标题
    window.open(_shareUrl, '_blank');
    e.stopPropagation();
  };
  render() {
    return (
      <div className="share-plan">
        <h3>乐分享 一起玩</h3>
        <div className="con">
          <div className="c1">
            <span className="qq" onClick={(e) => this.shareToqq(e)}>
              <p>QQ好友</p>
            </span>
            <span className="weibo" onClick={(e) => this.shareToSinaWB(e)}>
              <p>新浪微博</p>
            </span>
            <span className="qzone" onClick={(e) => this.shareToQzone(e)}>
              <p>QQ空间</p>
            </span>
            <span
              className="link"
              onClick={(e) => this.copyLink(e, this.props.url)}
            >
              <p>复制链接</p>
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Share, { withRef: true });
